import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import mr from './locales/mr.json';
import hi from './locales/hi.json';

const savedLang = localStorage.getItem("lang");
const defaultLang = ["en","mr","hi"].includes(savedLang) ? savedLang : "en";

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      mr: { translation: mr },
      hi: { translation: hi },
    },
    lng: defaultLang,
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
  });

i18n.on("languageChanged", (lng) => localStorage.setItem("lang", lng));

export default i18n;
